export const FETCH_AGENDA = 'FETCH_AGENDA'
export const SET_AGENDA = 'SET_AGENDA'
export const ROOM_TYPE_VIRTUAL = 'Formation à distance ZOOM'
